import { User } from '../../../types/user';

const API_URL = import.meta.env.VITE_API_URL;

export type QrSignInCode = {
  code: string;
  poll_secret: string;
  url: string;
  expires_in: number;
};

export type QrSignInPollArgs = {
  code: string;
  poll_secret: string;
};

export type QrSignInStatus =
  | { status: 'pending' }
  | { status: 'expired' }
  | { status: 'ready'; user: User; token: string };

/**
 * The two Web Sign-In Code calls. They sit beside the rest of the authentication surface but
 * deliberately do NOT go through RTK Query: a query or mutation dispatches Redux actions whose
 * `meta.arg` and payload carry `poll_secret`, which puts the private half of the code into the
 * action log (and the DevTools timeline on every non-production build). The backend's security
 * model rests on that value staying inside the tab that asked for it, so these are plain
 * requests that dispatch nothing and cache nothing.
 *
 * Both endpoints are unauthenticated — no token is attached.
 */
const post = async <T>(path: string, body?: unknown): Promise<T> => {
  const response = await fetch(`${API_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined
  });

  if (!response.ok) {
    throw new Error(`${path} responded ${response.status}`);
  }

  const payload = await response.json();
  return (payload?.data ?? payload) as T;
};

export const createQrSignInCode = () => post<QrSignInCode>('/qr/create');

export const readQrSignInStatus = (args: QrSignInPollArgs) => post<QrSignInStatus>('/qr/status', args);
